// PenKey (round 2): a technician's pen stroke beside their name, as the sample draws it beside every name
// on the board. The pen identifies the technician, never a state (DESIGN.md §2). It takes the type size
// of the line it sits in, so it serves a lane's head, a menu, a table cell and the map's legend alike.
// Reads only --penkey-*.
import type { ReactNode } from 'react';
import { penStyle, type Pen } from '../pen.ts';
import './PenKey.css';

export interface PenKeyProps {
  /** Their pen, 1 to 8; none draws the key muted (nobody, or a technician without one). */
  pen?: Pen | null;
  /** The name beside it. */
  children: ReactNode;
  /** Dashed: away from where they usually are (a technician moved to another division for the day). */
  dashed?: boolean;
}

export function PenKey({ pen, children, dashed }: PenKeyProps) {
  return (
    <span className="fl-penkey" style={penStyle('penkey', pen)} data-dashed={dashed ? '' : undefined}>
      <span className="fl-penkey__key" aria-hidden="true" />
      <span className="fl-penkey__name">{children}</span>
    </span>
  );
}
